import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthDirectLoginWithPasswordQuery, MpxResponseError } from '@cibo/core'
import { FormHelperText, Stack, Typography } from '@mui/material'
import VerifyCodeForm from '../RegisterVerifiedUserForm/VerifyCodeForm'

type Props = {
  code: string
  error?: MpxResponseError
  formAuthToken?: string
  onResendCode(): void
  onSubmit(values: AuthDirectLoginWithPasswordQuery): void
  username?: string
}

const DirectLoginCodeForm = ({
  code,
  error,
  formAuthToken,
  onResendCode,
  onSubmit,
  username,
}: Props) => {
  const { t } = useTranslation('auth')
  const [localCode, setLocalCode] = useState(code)

  const handleResendCode = () => {
    setLocalCode('')
    onResendCode()
  }

  useEffect(() => {
    setLocalCode(code)
  }, [code])

  return (
    <Stack spacing={4}>
      <Stack spacing={2}>
        <Stack spacing={1}>
          <Typography variant="h5">{t('newDevice')}</Typography>
          <Typography>{t('loginNewDevice')}</Typography>
        </Stack>
        <Typography sx={{ fontWeight: 'bold', lineBreak: 'anywhere' }}>{username}</Typography>
      </Stack>
      <VerifyCodeForm
        hideMessage
        initialValues={{
          formAuthToken,
          username,
          verifyCode: localCode || '',
        }}
        onResendCode={handleResendCode}
        onSubmit={onSubmit}
        submitLabel={t('login')}
      >
        {error?.httpCode === 400 && error?.message && (
          <FormHelperText error>{error.message}</FormHelperText>
        )}
      </VerifyCodeForm>
    </Stack>
  )
}

export default DirectLoginCodeForm
